// extracted by mini-css-extract-plugin
export default {"text_area_label":"TextArea_text_area_label__73yW+","descriptionErrorContainer":"TextArea_descriptionErrorContainer__NVxmr","error":"TextArea_error__V0uRz"};